// extracted by mini-css-extract-plugin
export var adjacentSlide = "_jd-9";
export var arrowButtonContainer = "_jd-5";
export var arrowButtonIcon = "_jd-6";
export var carouselArrowButton = "_jd-2";
export var carouselElementContainer = "_jd-1";
export var currentSlide = "_jd-8";
export var left = "_jd-3";
export var otherSlide = "_jd-a";
export var productCarouselContainer = "_jd-0";
export var right = "_jd-4";
export var sliderOverflow = "_jd-7";